import { render, staticRenderFns } from "./PharmacyCallHistoryTable.vue?vue&type=template&id=1f7f0c16&scoped=true&"
import script from "./PharmacyCallHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PharmacyCallHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./PharmacyCallHistoryTable.vue?vue&type=style&index=0&id=1f7f0c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f0c16",
  null
  
)

export default component.exports